export enum MapUnitEnum {
  m = 'm',
  ft = 'ft',
  'us-ft' = 'us-ft',
  degrees = 'degrees',
}
